import { functions } from 'config/ApiService';
import { httpsCallable } from 'firebase/functions';
import { isDevMode } from 'utils/AppEnv';

export default function sendPasswordResetEmail(email: string, isNewUser = false) {
    const baseResetPasswordLink = isDevMode(window.location.href)
        ? `${window.location.origin}/resetPassword`
        : `https://portal.phio.ai/resetPassword`;

    return httpsCallable(
        functions,
        'auth-sendCustomResetPasswordEmail'
    )({
        email,
        baseResetPasswordLink,
        isNewUser
    });
}
